/**
 * @generated SignedSource<<c4c5b0c916e6ceeb7ffeeef49ccbea7b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ValveModelInputValveModelsQuery$variables = {};
export type ValveModelInputValveModelsQueryVariables = ValveModelInputValveModelsQuery$variables;
export type ValveModelInputValveModelsQuery$data = {
  readonly valveModels: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly family: {
          readonly id: string;
        };
      };
    }>;
  };
};
export type ValveModelInputValveModelsQueryResponse = ValveModelInputValveModelsQuery$data;
export type ValveModelInputValveModelsQuery = {
  variables: ValveModelInputValveModelsQueryVariables;
  response: ValveModelInputValveModelsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ValveModelInputValveModelsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ValveModelConnection",
        "kind": "LinkedField",
        "name": "valveModels",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ValveModelEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ValveModel",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "family",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ValveModelInputValveModelsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ValveModelConnection",
        "kind": "LinkedField",
        "name": "valveModels",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ValveModelEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ValveModel",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "family",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3c5edffe3f467fc055616c5b1525abee",
    "id": null,
    "metadata": {},
    "name": "ValveModelInputValveModelsQuery",
    "operationKind": "query",
    "text": "query ValveModelInputValveModelsQuery {\n  valveModels {\n    edges {\n      node {\n        id\n        name\n        family {\n          __typename\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "27682a6c3f069b5929f23cf5f196a445";

export default node;
